import React from 'react';
import { Switch, Route } from 'react-router-dom';

import RootContainer from './RootContainer';
import BankConnectionContainer from './BankAccount/BankConnectionContainer';
import BankLogin from './BankAccount/BankLogin/BankLogin';
import ConnectionMethod from './ConnectionMethod/ConnectionMethod';
import CreditCardContainer from './CreditCard/CreditCardContainer';
import CreditCardConfirmContainer from './CreditCard/CreditCardConfirmContainer';
import NuveiCreditCard from './NuveiCreditCard/NuveiCreditCardContainer';
import ConnectionProcessor from './ConnectionProcessor.tsx/ConnectionProcessor';
import CrossRiverPushToCard from './PushToCard/CrossRiver/CrossRiverPushToCardContainer';
import Mastercard from './PushToCard/Mastercard/MastercardContainer';
import EmailContainer from './Email/EmailContainer';
import GenerateError from './Email/GenerateError/GenerateError';
import EmailForm from './Email/Form/EmailForm';
import DigitalWalletForm from './DigitalWallet/DigitalWalletForm';
import RequestFailed from './RequestFailed/RequestFailed';
import { CrossRiverMessage } from './PushToCard/CrossRiver/CrossRiverMessage';
import ConnectionError from './ConnectionError/ConnectionError';
import AccountVerification from './Verification/AccountVerification';
import AmountVerification from './Verification/AmountVerification/AmountVerification';
import VerificationResult from './Verification/VerificationResult/VerificationResult';
import FiservSuccess from './BankAccount/Fiserv/FiservSuccess';
import FiservError from './BankAccount/Fiserv/FiservError';
import FlexiblePaymentOptions from './FlexiblePayment/FlexiblePaymentOptions/FlexiblePaymentOptions';
import MultiplePaymentMethods from './FlexiblePayment/MultiplePayment/MultiplePaymentMethods';
import PartialPayment from './FlexiblePayment/PartialPayment/PartialPayment';
import InstallmentPlan from './FlexiblePayment/InstallmentPlan/InstallmentPlan';
import TransactionError from './Error/TransactionError';
import PaymentMethodContainer from './PaymentMethod/PaymentMethodContainer';
import PaymentMethodSummary from './PaymentMethod/PaymentMethodSummary';
import TokenRouteHandler from '../TokenRoute/TokenRouteHandler';
import OTPContainer from '../OTP/OTPContainer';
import Success from '../Messages/Success';
import Error from '../Messages/Error';
import Thankyou from '../Messages/Thankyou';
import Welcome from '../Messages/Welcome';
import BusinessProfileContainer from '../LoginAndSignup/BusinessProfile/BusinessProfileContainer';
import PersonalProfileContainer from '../LoginAndSignup/PersonalProfile/PersonalProfileContainer';
import ProfileType from '../LoginAndSignup/ProfileType/ProfileType';
import LoginContainer from '../LoginAndSignup/Login/LoginContainer';
import CreditCardFrame from './CreditCardFrame/CreditCardFrame';

const Routes = (): React.JSX.Element => (
  <Switch>
    <Route exact path="/">
      <RootContainer />
    </Route>
    <Route exact path="/connect">
      <ConnectionMethod />
    </Route>
    <Route exact path="/connnect/fiserv/success">
      <FiservSuccess />
    </Route>
    <Route exact path="/connect/fiserv/error">
      <FiservError />
    </Route>
    <Route exact path="/connect/processor/:PaymentSelectionMethod">
      <ConnectionProcessor />
    </Route>
    <Route exact path="/connect/bank">
      <BankConnectionContainer />
    </Route>
    <Route exact path="/connect/bank/:BankId/online">
      <BankLogin />
    </Route>
    <Route exact path="/connect/card">
      <CreditCardFrame />
    </Route>

    <Route exact path="/connect/credit-card">
      <CreditCardContainer />
    </Route>

    <Route exact path="/connect/nuvei-credit-card">
      <NuveiCreditCard type="credit" />
    </Route>

    <Route exact path="/connect/nuvei-debit-card">
      <NuveiCreditCard type="debit" />
    </Route>

    <Route exact path="/connect/cross-river-debit-card">
      <CrossRiverPushToCard />
    </Route>

    <Route exact path="/connect/cross-river-message/:Success">
      <CrossRiverMessage />
    </Route>

    <Route exact path="/connect/mastercard-debit-card">
      <Mastercard />
    </Route>

    <Route exact path="/connect/email">
      <EmailContainer />
    </Route>

    <Route exact path="/connect/email/form">
      <EmailForm />
    </Route>

    <Route exact path="/connect/email/generate-error">
      <GenerateError />
    </Route>

    <Route exact path="/connect/digital-wallet/:digitalWallet">
      <DigitalWalletForm />
    </Route>

    <Route exact path="/connect/error">
      <ConnectionError />
    </Route>

    <Route exact path="/connect/request-failed">
      <RequestFailed />
    </Route>

    <Route exact path="/connect/confirm">
      <CreditCardConfirmContainer />
    </Route>

    <Route exact path="/connect/account-verification">
      <AccountVerification />
    </Route>

    <Route exact path="/connect/amount-verification">
      <AmountVerification />
    </Route>

    <Route exact path="/connect/verification/:Status">
      <VerificationResult />
    </Route>

    <Route exact path="/connect/flexible-payment">
      <FlexiblePaymentOptions />
    </Route>

    <Route exact path="/connect/flexible-payment/multiple-payment-methods">
      <MultiplePaymentMethods />
    </Route>

    <Route exact path="/connect/flexible-payment/partial-payments">
      <PartialPayment />
    </Route>

    <Route exact path="/connect/flexible-payment/installment-plan">
      <InstallmentPlan />
    </Route>

    <Route exact path="/connect/transaction-error">
      <TransactionError />
    </Route>

    <Route exact path="/connect/payment-method">
      <PaymentMethodContainer />
    </Route>

    <Route exact path="/connect/payment-method/summary">
      <PaymentMethodSummary />
    </Route>

    <Route exact path="/Login">
      <LoginContainer />
    </Route>

    <Route exact path="/Profile-Type">
      <ProfileType />
    </Route>

    <Route exact path="/create-personal-profile">
      <PersonalProfileContainer />
    </Route>

    <Route exact path="/create-business-profile">
      <BusinessProfileContainer />
    </Route>

    <Route exact path="/welcome">
      <Welcome />
    </Route>

    <Route exact path="/thank-you">
      <Thankyou />
    </Route>

    <Route exact path="/error">
      <Error />
    </Route>

    <Route exact path="/success">
      <Success />
    </Route>

    <Route exact path="/account-verification">
      <AccountVerification />
    </Route>

    <Route exact path="/otp">
      <OTPContainer />
    </Route>

    <Route exact path="/:token">
      <TokenRouteHandler />
    </Route>
  </Switch>
);

export default Routes;
